import React from 'react'
import img3  from './../../images/sba-report-card_footer.jpg'
export default function ReportFooter() {
  return (
    <div>
    <img src={img3} style={{ width:"100%",height:"250px"}} alt='GovT of Punjab'  />
    </div>
  )
}
